import { defineStore } from "pinia";
import mushroom from "cem-probe-api";

export const listIcons = defineStore({
  id: "listIcons",
  state: () => ({
    arrayFileId: [],
    arrayCardItemIconIds: [],
  }),
  actions: {
    async getListIcons() {
      try {
        const response = await mushroom.icon.getAllAsync({}, { cacheAge: 1 });
        if (response.result) {
          this.arrayFileId = [];
          response.result.forEach((res) => {
            this.arrayFileId.push({
              id: res?.id,
              file_id: res?.file_id,
            });
          });
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async setListCardItemIconToStore() {
      try {
        const response = await mushroom.card_item_icon.getAllAsync(
          {},
          { cacheAge: 1 }
        );

        if (!response?.result?.length) {
          this.arrayCardItemIconIds = [];
          return;
        }

        this.arrayCardItemIconIds = response.result.map((item) => ({
          id: item?.id,
          code: item?.code,
          file_id: item?.file_id,
          icon_url: mushroom.$file.linkBuilder.thumb
            .id(item?.file_id)
            .clip(20, 20)
            .build(),
        }));
      } catch (error) {
        console.error("Lỗi khi lấy danh sách card item icons:", error);
        this.arrayCardItemIconIds = [];
      }
    },
  },
  getters: {
    listIcons: (state) => {
      return state.arrayFileId;
    },
    getListCardItemIcons: (state) => {
      return state.arrayCardItemIconIds;
    },
  },
});
